
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.824 12.907v-2.38c0-1.763-1.405-3.192-3.138-3.192-1.733 0-3.138 1.43-3.138 3.192v5.997c0 2-1.589 3.617-3.555 3.617-1.966 0-3.555-1.617-3.555-3.617v-2.11c3.124-.425 5.58-2.946 5.66-5.983V2.813a.949.949 0 00-.938-.954h-2.159A.948.948 0 009.072 1a.949.949 0 00-.938.955v1.712c0 .525.422.955.938.955.485 0 .844-.38.925-.859h1.23v4.668c0 2.283-2.106 4.142-4.682 4.142-2.572 0-4.682-1.859-4.682-4.142V3.763h1.176c.05.48.449.859.93.859.515 0 .888-.43.937-.955V1.955A.949.949 0 003.968 1a.942.942 0 00-.929.859H.929c-.507 0-.929.429-.929.95v5.617c0 3.037 2.41 5.563 5.57 5.983v2.115c0 3 2.434 5.476 5.383 5.476 2.994 0 5.382-2.43 5.476-5.476v-6.001c0-.713.561-1.284 1.262-1.284.7 0 1.261.571 1.261 1.284v2.347a2.216 2.216 0 00-1.261 1.987c0 1.192.938 2.192 2.154 2.192A2.168 2.168 0 0022 14.857a2.204 2.204 0 00-1.176-1.95zm-.983 2.283a.321.321 0 01-.328-.333c0-.192.14-.334.328-.334s.328.192.328.334c0 .192-.14.333-.328.333z","fill":"#8E8E92","fill-rule":"nonzero"}})])
          )
        }
      }
    